/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type DeliveredCarCategory =
  (typeof DeliveredCarCategory)[keyof typeof DeliveredCarCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeliveredCarCategory = {
  HomeDelivery: 1,
  Purchase: 2,
  Auction: 3,
  TradeIn: 4,
  InternalDelivery: 5,
  FacilityToFacility: 6,
  Other: 99,
} as const;
